import { unitId } from '@/annotations'

/**
 * A placeholder for a registered unit this pass has not built the content of yet. It carries the
 * REAL `data-scr` so the route resolves and the annotation contract is satisfied even though the
 * screen itself is a stub — the alternative (mounting nothing) would make the route table a lie
 * about what `process/03-SCREEN-INVENTORY.md` §0 says exists.
 */
export function NotYetBuilt({ unitId: id, title }: { unitId: string; title: string }) {
  return (
    <div data-scr={unitId(id)}>
      <h1 className="m-0 mb-4 text-section font-semibold">{title}</h1>
      <p className="text-tx2">This screen is registered but not yet built.</p>
    </div>
  )
}
